import ApiService from "./ApiService"
import appConfig from '../configs/app.config'

/*
{
    "project_name": "EfesTR"
}
EXAMPLE RESPONSE:
[
    {
        "class id": 0,
        "class name": "EFES-PILSEN-CAN-50CL",
        "sap code": "150021"
    },
    {
        "class id": 1,
        "class name": "EFES-MALT-CAN-50CL",
        "sap code": "151271"
    }
]

*/
export async function getProducts (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getProducts',
        method: 'post',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}

/*
{
    "project_name": "EfesTR",
  "file_name": "image_123.jpg",
  "notdetected_products": ["productA", "productB"],
  "misdetected_products": ["productC"],
  "duplicate_products": [],
  "new_products": ["productD", "productE"],
  "incorrect_image_type": "Karanlık resim",
  "note": ""
}

EXAMPLE RESPONSE:
{
    "message": "Saved successfully"
}
*/
export async function imageCheckResult (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'imageCheckResult',
        method: 'post',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}

/*
EXAMPLE RESPONSE
[
    {
        "help": "Kontrol edilen fotoğrafın dosya adını giriniz. (örn: foto_001.jpg)",
        "id": "file_name",
        "label": "Fotoğraf İsmi"
    },
    {
        "help": "Fotoğrafta bulunmasına rağmen sistem tarafından tespit edilemeyen ürünlerin listesini giriniz.",
        "id": "notdetected_products",
        "label": "Tespit Edilemeyen Ürünler"
    },
    {
        "help": "Sistem tarafından yanlış tanımlanan ürünleri giriniz.",
        "id": "misdetected_products",
        "label": "Yanlış Tespit Edilen Ürünler"
    },
    {
        "help": "Fotoğrafta bir üründe birden fazla etiket varsa, bu ürünleri giriniz.",
        "id": "duplicate_products",
        "label": "Duplike Ürünler"
    },
    {
        "help": "Katalogda bulunmayan ancak fotoğrafta görünen yeni ürünlerin listesini giriniz.",
        "id": "new_products",
        "label": "Yeni Ürünler"
    },
    {
        "help": "Fotoğrafın ışık durumu, açısı vs. uygun değilse belirtiniz.",
        "id": "incorrect_image_type",
        "label": "Hatalı Görüntü Tipi"
    },
    {
        "help": "Ek açıklamalar, özel durumlar veya diğer gözlemlerinizi buraya yazınız.",
        "id": "note",
        "label": "Not"
    }
]
*/
export async function getInfoTexts (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getInfoTexts',
        method: 'get',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}

/*
{
  "user_name": "sude.ekici",
  "project_name": "EfesTR"
}
  EXAMPLE RESPONSE:
  {
    "checked_files_count": 3,
    "date": "2025-07-04",
    "project_name": "EfesTR",
    "user_name": "sude.ekici"
}
*/
export async function getUserDailyCheckCount (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getUserDailyCheckCount?project_name=' + data.project_name,
        method: 'get',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}


// KPI Score Trends servisi
export async function getKPIscoreTrends () {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getKPIscoreTrends',
        method: 'get',
        headers: {'Content-Type' : 'application/json'}
    })
}

// KPI Score Performance servisi
export async function getKPIscorePer () {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getKPIscorePer',
        method: 'get',
        headers: {'Content-Type' : 'application/json'}
    })
}

// Eski getVariableService fonksiyonu (eski kodla uyumluluk için)
export async function getVariableService (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getVariable',
        method: 'post',
        data
    })
}


